var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6665 18.3333H11.8915L17.9465 11.0667C18.5365 10.36 18.4398 9.30834 17.7332 8.72001C17.0248 8.13001 15.9748 8.22668 15.3865 8.93334L7.05317 18.9333C6.98817 19.0117 6.95484 19.1033 6.9065 19.19C6.8665 19.26 6.81817 19.32 6.78817 19.3967C6.71317 19.5883 6.66817 19.79 6.66817 19.9933C6.66817 19.995 6.6665 19.9983 6.6665 20C6.6665 20.0017 6.66817 20.005 6.66817 20.0067C6.66817 20.21 6.71317 20.4117 6.78817 20.6033C6.81817 20.68 6.8665 20.74 6.9065 20.81C6.95484 20.8967 6.98817 20.9883 7.05317 21.0667L15.3865 31.0667C15.7165 31.4617 16.1898 31.6667 16.6665 31.6667C17.0432 31.6667 17.4215 31.54 17.7332 31.28C18.4398 30.6917 18.5365 29.64 17.9465 28.9333L11.8915 21.6667H31.6665C32.5865 21.6667 33.3332 20.92 33.3332 20C33.3332 19.08 32.5865 18.3333 31.6665 18.3333Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.0d5ffad66a29cc6132cf75f8e61501c6.svg";
export { ForwardRef as ReactComponent };